import { tw } from 'utils/classnames'

export function SkeletonItem({ className }: { className?: string }) {
  return <div className={tw('h-5 w-full rounded-[6px] bg-cf-grey-100 animate-pulse', className)} />
}
